import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  OnChanges,
  Renderer2,
  SimpleChanges,
} from '@angular/core';

@Directive({
  selector: '[directiveImage]',
})
export class ImageLoaderDirective implements OnChanges {
  @Input() src: string = '';
  @Input() defaultImage: string = '/assets/images/user.svg';
  @Input() loadingImage: string = '/assets/images/preloader.gif';
  @Input() timeout: number = 5000;
  private timeoutId: any;
  private imageLoaded = false;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['src']) {
      const currentSrc = changes['src'].currentValue;
      if (!currentSrc) {
        this.setImage(this.defaultImage);
      } else {
        this.loadImage(currentSrc);
      }
    }
  }

  private loadImage(src: string) {
    this.setImage(this.loadingImage);
    this.imageLoaded = false;

    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => {
      if (!this.imageLoaded) {
        this.setImage(this.defaultImage);
      }
    }, this.timeout);

    const img = new Image();
    img.onload = () => {
      this.imageLoaded = true;
      clearTimeout(this.timeoutId);
      this.setImage(src);
    };
    img.onerror = () => {
      clearTimeout(this.timeoutId);
      this.setImage(this.defaultImage);
    };
    img.src = src;
  }

  private setImage(src: string) {
    this.renderer.setAttribute(this.el.nativeElement, 'src', src);
  }
}
